module.exports = __webpack_public_path__ + "img/play_icon.8f0decb4.svg";